import { ACTION_TYPES } from './_actionTypes';
import { updateObject } from '../utility';

const initialState = {
	open: true,
};

const SET_OPEN_SIDEMENU = (state, action) => {
	return updateObject(state, {
		open: action.payload,
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case ACTION_TYPES.SET_OPEN_SIDE_MENU:
			return SET_OPEN_SIDEMENU(state, action);
		default:
			return state;
	}
};

export default reducer;
